export { default } from './ClassroomsSimpleList';
